import { gql } from '@apollo/client';

export const FETCH_CREW_MEMBER_EMPLOYMENT_TYPE = gql`
	query GetCrewMemberCurrentEmployment($id: ID!) {
		getCrewMember(id: $id) {
			currentEmploymentType {
				id
				employmentType
				effectiveTimestamp
			}
		}
	}
`;
